import { Component } from '@angular/core';
import { SectionContainerComponent } from '../section-container/section-container.component';
import { SectionHeadingComponent } from '../section-heading/section-heading.component';
import { FaqAccordionComponent } from '../faq-accordion/faq-accordion.component';
import { CardChipsComponent } from '../card/card-chips/card-chips.component';
import { RouterLink } from '@angular/router';
import { routes } from '../../../constants/routes';
import { ApiService } from '../../../services/api.service';
import { Faq, FaqData } from '../../../models/faq.model';
import { UtilityService } from '../../../services/utility.service';
import { NgIf } from '@angular/common';
import { NoRecordFoundComponent } from '../no-record-found/no-record-found.component';
import { CouldntLoadDataComponent } from '../couldnt-load-data/couldnt-load-data.component';
import { ApiErrorHandler } from '../../../models/api-error-handler.model';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { ToasterService } from '../../../services/toaster.service';

interface IFaqs {
  id: number;
  answer: string;
  question: string;
  isExpanded?: boolean;
}
@Component({
  selector: 'app-faq-section',
  standalone: true,
  imports: [
    SectionContainerComponent,
    CouldntLoadDataComponent,
    SectionHeadingComponent,
    NoRecordFoundComponent,
    FaqAccordionComponent,
    CardChipsComponent,
    RouterLink,
    NgIf,
  ],
  templateUrl: './faq-section.component.html',
  styleUrl: './faq-section.component.scss',
})
export class FaqSectionComponent implements ApiErrorHandler {
  routes = routes;
  faqList: FaqData[] = [];
  isErrorFetchFAQs: boolean = false;

  constructor(
    public toaster: ToasterService,
    private apiService: ApiService,
    private utilService: UtilityService
  ) {
    this.getFAQList();
  }

  getFAQList() {
    this.apiService.fetchFAQContent().subscribe({
      next: (resp) => {
        const faqList: Faq[] = resp;
        const sortedFaqList = this.utilService.sortListData(faqList, 'weight');
        this.faqList = this.filterFAQData(sortedFaqList);
      },
      error: (error) => {
        this.isErrorFetchFAQs = true;
        apiErrorHandler.call(this, error);
      },
    });
  }

  filterFAQData(faqs: Faq[]): FaqData[] {
    const gettingStartedFAQs = faqs.filter(
      (faq) => faq.body.title === 'Getting Started'
    );
    return gettingStartedFAQs
      ? gettingStartedFAQs[0]?.body?.data
      : faqs[0]?.body.data || [];
  }
}
